import styled from 'styled-components';
import { colors } from "colors";

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  a {
    text-decoration: none;
  }
`;

export const Title = styled.h1`
  font-weight: normal;
  font-size: 24px;
  color: ${colors.charcoalGrey};
`;

export const ButtonWrapper = styled.button`
  height: 48px;
  width: 240px;
  text-align: center;
  border-radius: 24px;
  display: flex;
  justify-content: center;

  background-image: linear-gradient(260deg, #fb5447, #cf1324);
  color: #fff;
  border: 0;
  svg {
    padding: 0 4px;
    height: 14px;
    width: 14px;
    fill: #fff;
  }

  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  outline: none;

  span {
    padding: 0 4px;
    font-size: 14px;
  }
`;

export const FilterWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  font-size: 14px;
  text-transform: capitalize;
  text-align: center;

  a {
    flex: 1;
    min-width: 144px;
    margin: 4px;
    padding: 16px 8px;
    background: ${colors.paleGrey};
    text-decoration: none;
    color: #878c90;
    font-weight: bold;
    border-radius: 4px;
    justify-content: space-around;
  }
  
  a:first-child {
    flex: 0;
    min-width: 96px;
  }
  
  a.active {
    color: white;
    background-color: ${colors.brightBlue};
    box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.2);
  }
  
  span {
    margin: 0 8px;
    padding: 8px;
    background-color: white;
    border-radius: 16px;
    color: #878c90;
  }
  
  a.active span {
    color: ${colors.brightBlue};
  }
`;

export const EmptyViewWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  
  padding: 32px;
  border-radius: 4px;
  min-width: 256px;
`;

export const ErrorViewWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  
  padding: 32px;
  border-radius: 4px;
  min-width: 256px;
`;
